class VideoSlider {
  constructor(el) {
    this.slider = el;
    this.track = el.querySelector('[data-slider-track]');
    this.cards = Array.from(el.querySelectorAll('[data-video-card]'));

    if (!this.track || this.cards.length === 0) return;

    this.init();
  }

  init() {
    // Play on card click
    this.cards.forEach((card) => {
      const playBtn = card.querySelector('[data-play-btn]');
      const video = card.querySelector('[data-video]');
      if (!playBtn || !video) return;

      playBtn.addEventListener('click', () => this.playCard(card));

      // Clicking the playing video pauses it and shows the thumbnail again
      video.addEventListener('click', () => this.resetCard(card));

      // When video ends, reset to thumbnail state
      video.addEventListener('ended', () => this.resetCard(card));
    });

  }

  playCard(card) {
    // Stop any other playing card first
    this.cards.forEach((c) => {
      if (c !== card && c.classList.contains('is-playing')) {
        this.resetCard(c);
      }
    });

    const video = card.querySelector('[data-video]');
    if (!video) return;

    card.classList.add('is-playing');
    video.play();
  }

  resetCard(card) {
    const video = card.querySelector('[data-video]');
    if (!video) return;

    video.pause();
    video.currentTime = 0;
    card.classList.remove('is-playing');
  }

}

// Init all sliders on the page
document.querySelectorAll('[data-video-slider]').forEach((el) => new VideoSlider(el));
